import { HasId } from '../interfaces';
import { User, ScoreCard } from '../models';

export class ScoreCardGroupCharacteristic implements HasId {
    public id: number;
    public name: string;
    public desc: string;
    public sort: number;
    public scoreCardGroupID: number;
    public scoreCardGroup: ScoreCardGroup;
    public showModal: boolean;
}

export class ScoreCardGroup implements HasId {
    public id: number;
    public name: string;
    public sort: number;
    public low: string;
    public medium: string;
    public high: string;
    public scoreCardID: number;
    public scoreCard: ScoreCard;
    public scoreCardGroupCharacteristics: ScoreCardGroupCharacteristic[];
}

export class UserScoreCardGroupCharacteristic implements HasId {
    public id: number;
    public userID: number;
    public user: User;
    public scoreCardGroupCharacteristicID: number;
    public scoreCardGroupCharacteristic: ScoreCardGroupCharacteristic;
    public score: number;
}

export class UserScoreCardNote implements HasId {
    public id: number;
    public userID: number;
    public user: User;
    public content: string;
    public created: Date;
    public createdByUserID: number;
    public createdByUser: User;
    public isPublic: boolean;
    public scoreCardID: number;
}


// WEBPACK FOOTER //
// ./src/models/ScoreCardGroup.tsx